module.exports = __webpack_public_path__ + "img/404.08abce2e.svg";